import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RadiologyOrderSubject } from 'src/app/Models/radiologyordersubject.model';
import { RadilogyOrderSubjectService } from 'src/app/services/radilogy-order-subject.service';

@Component({
  selector: 'app-view-radiology-order-subject',
  templateUrl: './view-radiology-order-subject.component.html',
  styleUrls: ['./view-radiology-order-subject.component.css'],
})
export class ViewRadiologyOrderSubjectComponent implements OnInit {
  displayedColumns: string[] = ['Subject', 'Delete'];
  subjectList: RadiologyOrderSubject[] = [];
  dataSource: MatTableDataSource<any>;

  selectedFile: File;

  constructor(
    private RadiologyOrderSubjectService: RadilogyOrderSubjectService
  ) {}

  ngOnInit(): void {
    this.getRadiologyOrderSubject();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getRadiologyOrderSubject() {
    this.RadiologyOrderSubjectService.getRadiologyOrderSubjects().subscribe(
      (res) => {
        // this.RadiologyOrderSubjectList = res;

        this.dataSource = new MatTableDataSource(res);
        this.dataSource.paginator = this.paginator;
      }
    );
  }

  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.getRadiologyOrderSubject();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0];
  }

  uploadFile() {
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, 'UTF-8');
    fileReader.onload = () => {
      const fileContent = fileReader.result;
      try {
        const data = JSON.parse(fileContent as string);

        // Validate the data structure
        if (!Array.isArray(data.RadiologyOrderSubjectItems)) {
          alert('Invalid data structure');
        }
        data.RadiologyOrderSubjectItems.forEach((sub) => {
          if (typeof sub.Subject !== 'string') {
            alert('Invalid data structure');
          }
          // Add more checks as necessary...
        });

        this.RadiologyOrderSubjectService.UploadJsonData(data).subscribe(
          (res) => {
            alert('Upload With success');
            this.getRadiologyOrderSubject();
          },
          (err) => {
            alert('Error uploading the data');
          }
        );
        // this.http.post('https://your-api-url.com/upload', data)
        // .subscribe(
        //     response => console.log(response),
        //     error => console.log(error)
        // );
      } catch (error) {
        console.error('Invalid JSON format:', error);
      }
    };
    fileReader.onerror = (error) => console.log(error);
  }

  deleteSubject(subjectId) {
    this.RadiologyOrderSubjectService.deleteRadiologyOrderSubject(
      subjectId
    ).subscribe(
      (res) => {
        alert('Subject Delete with success');
        this.getRadiologyOrderSubject();
      },
      (err) => {
        alert('Unsuccessful');
      }
    );
  }
}
